import { Component, OnInit, ViewEncapsulation, TemplateRef, HostListener, ElementRef, ViewChild} from '@angular/core';
import { Title, Meta} from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ScrollToService } from 'ng2-scroll-to-el';
import { NgsRevealConfig } from 'ng-scrollreveal';
import { ScrollimateService } from 'ng2-scrollimate';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('elementState', [
      state('inactive', style({
        opacity: 0,
        visibility: 'hidden',
        display: 'none',
      })),
      state('hidden', style({
        opacity: 0,
        visibility: 'hidden',
      })),
      state('active', style({
        opacity:  1,
        visibility: 'visible',
      })),
      state('fadeIn', style({
        opacity:  1,
        visibility: 'visible',
      })),
      state('fadeIn2', style({
        opacity:  1,
        visibility: 'visible',
      })),
      state('fadeIn3', style({
        opacity:  1,
        visibility: 'visible',
      })),
      state('transLeftHidden', style({
        transform: 'translateX(-800px)',
      })),
      state('transLeft', style({
        transform: 'none',
      })),
      state('transLeft2', style({
        transform: 'none',
      })),
      state('transRightHidden', style({
        transform: 'translateX(800px)',
      })),
      state('transRight', style({
        transform: 'none',
      })),
      state('transRight2', style({
        transform: 'none',
      })),
      state('green', style({
        backgroundColor: 'green',
        color: '#fff'
      })),
      state('text-bold', style({
        fontWeight: 'bold',
        fontSize: '1.1em'
      })),
      transition('* => active', animate('50ms')),
      transition('* => fadeIn', animate('200ms ease-in')),
      transition('* => fadeIn2', animate('300ms ease-in')),
      transition('* => fadeIn3', animate('600ms ease-in')),
      transition('* => transLeft', animate('200ms ease-in')),
      transition('* => transLeft2', animate('500ms ease-in')),
      transition('* => transRight', animate('200ms ease-in')),
      transition('* => transRight2', animate('500ms ease-in')),
      transition('* => blue', animate('200ms ease-in')),
      transition('* => text-bold', animate('200ms ease-in')),
      transition('* => inactive', animate('50ms')),
    ])
  ]
})

export class HomeComponent implements OnInit {
  @ViewChild('video', {read: TemplateRef}) video: TemplateRef<any>;

  scrollimateOptions: any = {
    defaultStates: [
      {
        method: 'default',
        state: 'inactive',
      }
    ],
    number01: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 26,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    number02: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 40,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 27,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    number03: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 51,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 41,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    number04: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 65,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 52,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    number05: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 75,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 66,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    number06: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 87,
          state: 'inactive',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 76,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    number07: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 88,
          state: 'active',
          setAtLastChance: false
        },

        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    percentTotal: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 15,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'inactive'
        }
      ]
    },
    block1Text: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 5,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block1Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 5,
          state: 'fadeIn',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block1Img: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 11,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block1Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 10,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block2Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 20,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block2Text: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 22,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block2Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 17,
          state: 'fadeIn',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block3Text: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 33,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block3Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 33,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block3Img: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 40,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block3Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 37,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block4Text: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 47,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block4Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 47,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block4Img: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 51,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block4Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 50,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },

    block5Text: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 62,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block5Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 65,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block5Img: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 65,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block5Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 68,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },

    // block6Text: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 75,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block6Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 75,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block6Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 78,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },

    block7Text: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 87,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    block7Details: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 87,
          state: 'fadeIn2',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
    // block7Img: {
    //   currentState: 'active',
    //   states: [
    //     {
    //       method: 'percentTotal',
    //       value: 87,
    //       state: 'fadeIn',
    //       setAtLastChance: false
    //     },
    //     {
    //       method: 'default',
    //       state: 'hidden'
    //     }
    //   ]
    // },
    block7Number: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 90,
          state: 'fadeIn3',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'hidden'
        }
      ]
    },
  };

  modalRef: BsModalRef;
  closeMod: Boolean = false;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false
  };

  constructor(
    public el: ElementRef,
    private titleService: Title,
    private metaService: Meta,
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute,
    private scrollimateService: ScrollimateService,
    private translate: TranslateService,
  ) {
    scrollimateService.setDefaultStates(this.scrollimateOptions.defaultStates);
  }

  percentTotal(event: any) {
    this.scrollimateOptions.percentTotal.currentValue = event.currentValue || this.scrollimateOptions.percentTotal.currentValue;
  }

  number01(event: any) {
    this.scrollimateOptions.number01.currentValue = event.currentValue || this.scrollimateOptions.number01.currentValue;
  }
  number02(event: any) {
    this.scrollimateOptions.number02.currentValue = event.currentValue || this.scrollimateOptions.number02.currentValue;
  }

  number03(event: any) {
    this.scrollimateOptions.number03.currentValue = event.currentValue || this.scrollimateOptions.number03.currentValue;
  }
  number04(event: any) {
    this.scrollimateOptions.number04.currentValue = event.currentValue || this.scrollimateOptions.number04.currentValue;
  }
  number05(event: any) {
    this.scrollimateOptions.number05.currentValue = event.currentValue || this.scrollimateOptions.number05.currentValue;
  }
  number06(event: any) {
    this.scrollimateOptions.number06.currentValue = event.currentValue || this.scrollimateOptions.number06.currentValue;
  }
  number07(event: any) {
    this.scrollimateOptions.number07.currentValue = event.currentValue || this.scrollimateOptions.number07.currentValue;
  }

  block1Text(event: any) {
    this.scrollimateOptions.block1Text.currentValue = event.currentValue || this.scrollimateOptions.block1Text.currentValue;
  }
  block1Img(event: any) {
    this.scrollimateOptions.block1Img.currentValue = event.currentValue || this.scrollimateOptions.block1Img.currentValue;
  }
  block1Details(event: any) {
    this.scrollimateOptions.block1Details.currentValue = event.currentValue || this.scrollimateOptions.block1Details.currentValue;
  }
  block1Number(event: any) {
    this.scrollimateOptions.block1Number.currentValue = event.currentValue || this.scrollimateOptions.block1Number.currentValue;
  }

  block2Number(event: any) {
    this.scrollimateOptions.block2Number.currentValue = event.currentValue || this.scrollimateOptions.block2Number.currentValue;
  }
  block2Text(event: any) {
    this.scrollimateOptions.block2Text.currentValue = event.currentValue || this.scrollimateOptions.block2Text.currentValue;
  }
  block2Details(event: any) {
    this.scrollimateOptions.block2Details.currentValue = event.currentValue || this.scrollimateOptions.block2Details.currentValue;
  }

  block3Text(event: any) {
    this.scrollimateOptions.block3Text.currentValue = event.currentValue || this.scrollimateOptions.block3Text.currentValue;
  }
  block3Img(event: any) {
    this.scrollimateOptions.block3Img.currentValue = event.currentValue || this.scrollimateOptions.block3Img.currentValue;
  }
  block3Details(event: any) {
    this.scrollimateOptions.block3Details.currentValue = event.currentValue || this.scrollimateOptions.block3Details.currentValue;
  }
  block3Number(event: any) {
    this.scrollimateOptions.block3Number.currentValue = event.currentValue || this.scrollimateOptions.block3Number.currentValue;
  }

  block4Text(event: any) {
    this.scrollimateOptions.block4Text.currentValue = event.currentValue || this.scrollimateOptions.block4Text.currentValue;
  }
  block4Img(event: any) {
    this.scrollimateOptions.block4Img.currentValue = event.currentValue || this.scrollimateOptions.block4Img.currentValue;
  }
  block4Details(event: any) {
    this.scrollimateOptions.block4Details.currentValue = event.currentValue || this.scrollimateOptions.block4Details.currentValue;
  }
  block4Number(event: any) {
    this.scrollimateOptions.block4Number.currentValue = event.currentValue || this.scrollimateOptions.block4Number.currentValue;
  }

  block5Text(event: any) {
    this.scrollimateOptions.block5Text.currentValue = event.currentValue || this.scrollimateOptions.block5Text.currentValue;
  }
  block5Img(event: any) {
    this.scrollimateOptions.block5Img.currentValue = event.currentValue || this.scrollimateOptions.block5Img.currentValue;
  }
  block5Details(event: any) {
    this.scrollimateOptions.block5Details.currentValue = event.currentValue || this.scrollimateOptions.block5Details.currentValue;
  }
  block5Number(event: any) {
    this.scrollimateOptions.block5Number.currentValue = event.currentValue || this.scrollimateOptions.block5Number.currentValue;
  }

  block6Number(event: any) {
    this.scrollimateOptions.block6Number.currentValue = event.currentValue || this.scrollimateOptions.block6Number.currentValue;
  }
  block6Text(event: any) {
    this.scrollimateOptions.block6Text.currentValue = event.currentValue || this.scrollimateOptions.block6Text.currentValue;
  }
  block6Details(event: any) {
    this.scrollimateOptions.block6Details.currentValue = event.currentValue || this.scrollimateOptions.block6Details.currentValue;
  }

  block7Text(event: any) {
    this.scrollimateOptions.block7Text.currentValue = event.currentValue || this.scrollimateOptions.block7Text.currentValue;
  }
  block7Img(event: any) {
    this.scrollimateOptions.block7Img.currentValue = event.currentValue || this.scrollimateOptions.block7Img.currentValue;
  }
  block7Details(event: any) {
    this.scrollimateOptions.block7Details.currentValue = event.currentValue || this.scrollimateOptions.block7Details.currentValue;
  }
  block7Number(event: any) {
    this.scrollimateOptions.block7Number.currentValue = event.currentValue || this.scrollimateOptions.block7Number.currentValue;
  }

  ngOnInit(): void {
    if (this.translate.currentLang === 'en') {
      this.titleService.setTitle('Voyager, The perfect path - Modern office space in Rueil Malmaison');
      this.metaService.addTags([
        { name: 'description', content: 'Voyager is an all-new flexible, modern office space located in Rueil-Malmaison. 38 292 SQ.M are divisible.' },
        { name: 'keywords', content: 'Real estate, office, workplace, campus, Novartis' }
      ]);
    } else if (this.translate.currentLang === 'fr') {
      this.titleService.setTitle('Voyager, The perfect path - Immeuble de bureaux à Rueil-Malmaison');
      this.metaService.addTags([
        { name: 'description', content: 'Voyager est un immeuble de bureaux à louer divisibles situé à Rueil-Malmaison. 38 292 m2 sont divisibles.' },
        { name: 'keywords', content: 'Immobilier, tertiaire, location, bureaux, campus, Novartis' }
      ]);
    }

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (this.translate.currentLang === 'en') {
        this.titleService.setTitle('Voyager, The perfect path - Modern office space in Rueil-Malmaison');
        this.metaService.updateTag({
          name: 'description',
          content: 'Voyager is an all-new flexible, modern office space located in Rueil-Malmaison. 38 292 SQ.M are divisible.'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Real estate, office, workplace, campus, Novartis'
        });
      } else if (this.translate.currentLang === 'fr') {
        this.titleService.setTitle('Voyager, The perfect path - Immeuble de bureaux à Rueil-Malmaison');
        this.metaService.updateTag({
          name: 'description',
          content: 'Voyager est un immeuble de bureaux à louer divisibles situé à Rueil-Malmaison. 38 292 m2 sont divisibles.'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Immobilier, tertiaire, location, bureaux, campus, Novartis'
        });
      }
    });
  }

  openVideo(video: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      video,
      Object.assign({}, this.config, { class: 'home-modal modal-lg' })
    );

    const audio = <HTMLAudioElement>document.getElementById('videoMod');
    audio.play();
    audio.onended = () => this.modalRef.hide();
  }

  closeFirstModal() {
    const audio = <HTMLAudioElement>document.getElementById('videoMod');

    this.modalRef.hide();
    // this.modalRef = null;
    audio.pause();
  }

  goToHub ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('#hub');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }

  goToSurroundings ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('#surroundings');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }

  goToSpace ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('#space-planning');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }

  goToCertif ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('#certif');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts